<template>
    <div >
        <router-view></router-view>
    </div>
</template>

<script>
export default {

}
</script>
<style>
*{
    margin:0px;
    padding: 0px;
    border-radius: 0px;
}
</style>